import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-16">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-brand-stone hover:text-brand-ink font-ui mb-10">
        <ArrowLeft className="w-4 h-4" /> Back to home
      </Link>
      <div className="eyebrow">{eyebrow}</div>
      <h1 className="mt-3 font-display text-5xl sm:text-6xl text-brand-ink leading-none">{title}</h1>
      <p className="mt-4 text-xs tracking-[0.24em] uppercase text-brand-stone font-ui font-semibold">Last updated · {updated}</p>
      <div className="dot-divider mt-10" />
      <article className="mt-10 space-y-8 font-ui text-brand-ink leading-[1.7] text-[15px] legal-content">
        {children}
      </article>
    </div>
  );
}

export const Section = ({ n, title, children }) => (
  <section>
    <h2 className="font-display text-2xl text-brand-ink mt-2 mb-3">
      <span className="text-brand-red mr-2">{n}.</span>{title}
    </h2>
    <div className="space-y-3 text-brand-stone">{children}</div>
  </section>
);
